module.exports = __webpack_public_path__ + "media/images/loghi/lbacares-327ec0b5e98fc22b46eb82e03f65f7a2.png";